<template>
  <div class="return-notes-list tab-table p-2">
    <return-notes-table/>
  </div>
</template>


<script>
  import {createNamespacedHelpers} from "vuex";
  import ReturnNotesTable from "@/modules/return-notes/ReturnNotesTable";

  const {mapState} = createNamespacedHelpers('receipts');
  const {mapActions: returnNotesMapActions} = createNamespacedHelpers('returnNotes');

  export default {
    name: "ReturnNotesList",
    components: {ReturnNotesTable},
    computed: {
      ...mapState({
        receipt: state => state.view.currentReceipt
      })
    },
    methods: {
      ...returnNotesMapActions(['updateTableSource'])
    },
    async beforeMount() {
      await this.updateTableSource({
        source: 'receipt',
        extraFilters: {
          receipt_uuid: this.receipt.uuid
        }
      });
    }
  }
</script>

<style lang="scss" scoped>
</style>
